import { session } from "./session";
import { getWorkspace } from "./workspaceStore";

function scope(workspaceId = getWorkspace()?.id) {
  const owner = session.getEmail()?.trim().toLowerCase();
  if (!owner || !workspaceId) return null;
  return { owner, workspaceId: String(workspaceId), key: `omnimark_product_handoff:v1:${encodeURIComponent(owner)}:${encodeURIComponent(String(workspaceId))}` };
}

export function saveProductHandoff(product, workspaceId) {
  const context = scope(workspaceId);
  if (!context) throw new Error("Sign in and select a workspace before sending a product to another tool.");
  if (!product || typeof product.product !== "string" || !product.product.trim()) throw new Error("Choose a product before continuing.");
  try {
    localStorage.setItem(context.key, JSON.stringify({ version: 1, owner: context.owner, workspaceId: context.workspaceId, product }));
  } catch {
    throw new Error("The product handoff could not be saved in this browser. Free browser storage or enable site storage, then try again.");
  }
}

export function getProductHandoff(workspaceId) {
  const context = scope(workspaceId);
  if (!context) return null;
  try {
    const saved = JSON.parse(localStorage.getItem(context.key) || "null");
    if (saved?.version !== 1 || saved.owner !== context.owner || saved.workspaceId !== context.workspaceId || typeof saved.product?.product !== "string") return null;
    return saved.product;
  } catch { return null; }
}
